import { render, staticRenderFns } from "./GiveRecognition.vue?vue&type=template&id=384b4af0&scoped=true&"
import script from "./GiveRecognition.vue?vue&type=script&lang=js&"
export * from "./GiveRecognition.vue?vue&type=script&lang=js&"
import style0 from "./GiveRecognition.vue?vue&type=style&index=0&id=384b4af0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b4af0",
  null
  
)

export default component.exports